import React, { Component } from "react";
import { Link } from "react-router-dom";
import BackendClient from "../../BackendClient";

export default class OfficeLayoutSidebar extends Component {
  state = {
    widgetTextMap: new Map()
  };

  componentWillUnmount() {
    this.isCancelled = true;
  }

  componentDidMount() {
    const { isFetched, isFetching } = this.state;
    if (!(isFetched && isFetching)) {
      !this.isCancelled &&
        BackendClient.getWidgetText({ title: "frontend.layouts.sidebar" })
          .fetchJson()
          .then(res => {
            const widgetTextMap = new Map(
              (res || []).map(({ key, body }) => [key, body])
            );
            !this.isCancelled &&
              this.setState({
                widgetTextMap
              });
          });
    }
  }

  getWidgetText = key => this.state.widgetTextMap.get(key) || "";

  renderWidgetBlock = (type, blockKey, props = {}) => {
    const __html = this.getWidgetText(blockKey) || "";
    return React.createElement(type, {
      ...props,
      dangerouslySetInnerHTML: { __html }
    });
  };
  
  render() {
    const { renderWidgetBlock: getBlock } = this;
    return (
      <div className="office-sidebar">
        <div className="logo">
          <Link to="/">
            <img src="/images/logo.png" alt="" />
          </Link>
        </div>
        <ul className="office-menu">
          <li>
            <div className="office-menu-icon">
              <img src="/images/icon-side-main.png" alt="" />
            </div>
            {getBlock(Link, "frontend.layouts.sidebar.home", { to: "/" })}
          </li>
          <li>
            <div className="office-menu-icon">
              <img src="/images/icon-side-statistic.png" alt="" />
            </div>
            {getBlock(Link, "frontend.layouts.sidebar.reportsSummary", {
              to: "/reports-summary"
            })}
          </li>
          <li>
            <div className="office-menu-icon">
              <img src="/images/icon-side-clock.png" alt="" />
            </div>
            {getBlock(Link, "frontend.layouts.sidebar.schedule", {
              to: "/schedule"
            })}
          </li>
          <li>
            <div className="office-menu-icon">
              <img src="/images/icon-side-graphic.png" alt="" />
            </div>
            {getBlock(Link, "frontend.layouts.sidebar.releaseSchedule", {
              to: "#"
            })}
          </li>
          <li>
            <div className="office-menu-icon">
              <img src="/images/icon-side-otchet.png" alt="" />
            </div>
            {getBlock(Link, "frontend.layouts.sidebar.reportsDownload", {
              to: "/reports-download"
            })}
          </li>
          <li>
            <div className="office-menu-icon">
              <img src="/images/icon-side-box.png" alt="" />
            </div>
            {getBlock(Link, "frontend.layouts.sidebar.accountingDocuments", {
              to: "/accounting-documents"
            })}
          </li>
        </ul>
        <hr className="office-hr" />
        <ul className="office-menu">
          <li>
            <div className="office-menu-icon">
              <img src="/images/icon-side-note.png" alt="" />
            </div>
            {getBlock(Link, "frontend.layouts.sidebar.employeeContacts", {
              to: "/employee-contacts"
            })}
          </li>
          <li>
            <div className="office-menu-icon">
              <img src="/images/icon-side-news.png" alt="" />
            </div>
            {getBlock(Link, "frontend.layouts.sidebar.news", {
              to: "/news"
            })}
          </li>
          <li>
            <div className="office-menu-icon">
              <img src="/images/icon-side-services.png" alt="" />
            </div>
            {getBlock(Link, "frontend.layouts.sidebar.services", {
              to: "/services"
            })}
          </li>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/layout/_officeSidebar.jsx